export const PAID_PLANS = ['BUSINESS', 'UNLIMITED', 'PREMIUM'];

export const APP_SUMO_PLAN = 'PROFESSIONAL';

export const FREE_PASS_LIMIT = 0;
